import { render, staticRenderFns } from "./NextApprovalModal.vue?vue&type=template&id=156c34e4"
import script from "./NextApprovalModal.vue?vue&type=script&lang=js"
export * from "./NextApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports